import { io, Socket } from "socket.io-client"
import { getSocketsUrl } from "utils/getSocketsUrl"
import { TAGS, api } from "../../api"
import {
  IInfoModal,
  IInfoModalReq,
  IInfoModalRead,
  INFO_MODAL_TYPE
} from "./types"

export const newsModalsSocket = {
  instance: null as Socket | null,
  init(type: INFO_MODAL_TYPE, lang: string, callback: (data: any) => void) {
    if (this.instance) return
    this.instance = io(`${getSocketsUrl()}/news_modals`, {
      transports: ["websocket"],
      auth: {
        lang,
        type
      },
      upgrade: false,
      reconnection: true,
      reconnectionAttempts: 5,
      reconnectionDelay: 1000,
      reconnectionDelayMax: 5000,
      timeout: 20000,
      autoConnect: true,
      forceNew: true
    })

    this.instance.on("connect", () => {
      this.handleNewsUpdate(callback)
    })

    this.instance.on("connect_error", (error) => {
      console.error("News Socket connection error:", error)
    })

    this.instance.on("disconnect", (reason) => {
      console.warn("News Socket disconnected:", reason)
    })
  },

  handleNewsUpdate(callback: (data: any) => void) {
    if (!this.instance) return

    this.instance.on("news_modals:get_updated", (message: string) => {
      try {
        const parsed = JSON.parse(message)
        callback(parsed)
      } catch (err) {
        console.error("Invalid JSON from news socket:", message)
      }
    })
  },

  disconnect() {
    if (!this.instance) return
    this.instance.off("news_models:get_updated")
    this.instance.disconnect()
    this.instance = null
  }
}

const TAG = TAGS.INFO_MODALS

const infoModalsAPI = api.enhanceEndpoints({ addTagTypes: [TAG] })

export const infoModalsEndpoints = infoModalsAPI.injectEndpoints({
  endpoints: (builder) => ({
    getHasRead: builder.mutation<boolean, IInfoModalReq>({
      query: ({ type, lang }) => ({
        url: `/info-modals/has-red/${type}/${lang}`,
        method: "GET"
      })
    }),
    markHasRead: builder.mutation<boolean, string>({
      query: (userId) => ({
        url: `/info-modals/mark-as-read/${userId}`,
        method: "PATCH"
      })
    }),
    getInfoModal: builder.query<IInfoModal, IInfoModalReq>({
      query: ({ type, lang }) => ({
        url: `/info-modals/${type}/${lang}`,
        method: "GET"
      }),
      // @ts-ignore
      providesTags: (res, _, { type, lang }) => [
        { type: TAG, id: `MODAL_${type}_${lang}` }
      ]
    }),
    getInfoModalRead: builder.query<IInfoModalRead, IInfoModalReq>({
      query: ({ type, lang }) => ({
        url: `/info-modals/read-user-data/${type}/${lang}`,
        method: "GET"
      }),
      // @ts-ignore
      providesTags: (res, _, { type, lang }) => [
        { type: TAG, id: `MODAL_READ_${type}_${lang}` }
      ]
    })
  })
})
